import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { firmIdValidator } from 'src/app/helpers/field-validators';
import { LoginForm } from 'src/app/models/authentication.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { OnlineClientService } from 'src/app/services/online-client.service';
import { ToastService } from 'src/app/services/toast.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'tx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {
  error: string = '';
  loginForm = new FormGroup({
    firmId: new FormControl('', [Validators.required, firmIdValidator]),
    password: new FormControl('', Validators.required),
    initials: new FormControl('', [Validators.required, Validators.maxLength(5)]),
  });
  model: LoginForm = { firmId: '', password: '' };
  loading: boolean = false;
  apiCall: Subscription = new Subscription();
  bodyClass = 'overflow-auto';
  hasInvalidInitials = false;
  hasInvalidCredentials = false;
  @ViewChild('firmId') firmIdInput!: ElementRef;
  
  constructor(public authService: AuthenticationService, private router: Router, private renderer: Renderer2) {}

  ngOnInit(): void {
    document.title = environment.name;
    this.authService.clearTimers();
    this.renderer.addClass(document.body, this.bodyClass);
  }

  ngAfterViewInit(): void {
    this.firmIdInput.nativeElement.focus();
  }

  login() {
    if (this.loginForm.valid) {
      this.loading = true;
      this.loginForm.disable();
      this.model.firmId = this.model.firmId?.toUpperCase();
      this.model.initials = this.model.initials?.toUpperCase();
      this.apiCall = this.authService.login(this.model).subscribe({
        next: (res) => {
          this.clearLoading();
          if (res.contentUpdatePending) {
            this.router.navigate(['content-update']);
          } else {
            this.router.navigate(['']);
          }
        },
        error: (e) => {
          console.log(`error = ${e}`);
          this.setError(e);
          this.clearLoading();
          if (!this.hasInvalidCredentials && !this.hasInvalidInitials) {
            //INTERNAL USE ONLY - DO NOT DISPLAY ERRORS TO END USER
            // this.toastService.show(this.error, {
            //   classname: 'bg-danger text-light',
            //   autohide: false,
            // });
          }
        },
      });
    }
  }

  setError(e: any) {
    if (e) {
      this.error = typeof e === 'string' ? e : 'An unknown error has occured. Please try again later.';
      this.hasInvalidCredentials = this.error.includes('credentials');
      this.hasInvalidInitials = this.error.includes('initials');
    }
  }

  clearError() {
    this.error = '';
    this.hasInvalidCredentials = false;
    this.hasInvalidInitials = false;
  }

  fieldInvalid(fieldName: string) {
    return (
      (this.loginForm.get(fieldName)?.dirty || this.loginForm.get(fieldName)?.touched) &&
      this.loginForm.get(fieldName)?.invalid
    );
  }

  ngOnDestroy(): void {
    this.apiCall?.unsubscribe();
    this.renderer.removeClass(document.body, this.bodyClass);
  }

  private clearLoading() {
    this.loginForm.enable();
    this.loading = false;
  }
}
